import RelatedEntitiesLanding from './RelatedEntitiesLanding';
export default RelatedEntitiesLanding;
